const CanViewNavGroup = () => {
  return null
}

export default CanViewNavGroup
